<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/br5Inz/tc-custom/9781504099608.jpg?1730488363220" alt="This image is the cover for the book Spinster's Fortune"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Spinster's Fortune
      </h1>
      <p class="bookDescription body article font2">
        <b>A woman searches for her ailing aunt’s hidden riches in this “perfect blend of history, mystery, family secrets and suspense” (Kate Braithwaite, author of <i>The Puzzle of Nelly Bly</i>).</b><br/><br/> In 1929, Blanche Magruder lies alone in a home for the elderly and infirm without a penny to her name, suspected of being of unsound mind. Meanwhile, her house, a crumbling ruin in the Georgetown section of Washington, DC, is regularly ransacked by thieves looking for a fortune believed to be hidden there.<br/><br/> When distant niece Margaret O’Keefe is made executor of Blanche’s estate, she becomes embroiled in the treasure hunt, embracing it as a welcome escape from her own financial and marital woes. But as Margaret continues to investigate, family mysteries begin to unravel. Soon, she begins to question whether Aunt Blanche<i> is</i> a senile fool, and whether she really belongs in the home. But can she find out where the lies end and the truth begins?<br/><br/> Shrouded in gothic undertones, <i>The Spinster’s Fortune</i> is a strange and twisting journey through tangled webs of family deceit.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Mary Kendall
      </h2>
      
      <p class="authorDescription body article">Mary Kendall is first a reader of all books across the genres and, second, a writer of fiction. She brings her background in history-related fields to her writing along with some Celtic story-telling genes. Fueled by black coffee and a possible sprinkling of fairy dust, she tends to find inspiration in odd places and sometimes while kneading bread dough. She has two published novels, The Spinster&#39;s Fortune (historical mystery) and Campbell&#39;s Boy (coming of age, historical fiction). Her third novel, Bottled Secrets of Rosewood, is a contemporary gothic thriller to be released in Summer 2024. She also has three short stories published in dark fiction anthologies for charity.<BR /> &#160;</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Bloodhound Books
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?762d08df